import { type IProduct } from '../interface/types'

import burger1 from '../assets/burger/burger1.png'
import burger2 from '../assets/burger/burger2.png'
import burger3 from '../assets/burger/burger3.png'
import burger4 from '../assets/burger/burger4.png'
import burger5 from '../assets/burger/burger5.png'
import burger6 from '../assets/burger/burger6.png'
import burger7 from '../assets/burger/burger7.png'
import burger8 from '../assets/burger/burger8.png'
import burger9 from '../assets/burger/burger9.png'
import burger10 from '../assets/burger/burger10.png'

import breakfast1 from '../assets/breakfast/breakfast1.png'
import breakfast2 from '../assets/breakfast/breakfast2.png'

import dessert1 from '../assets/dessert/dessert1.png'
import dessert2 from '../assets/dessert/dessert2.png'
import dessert3 from '../assets/dessert/dessert3.png'
import dessert4 from '../assets/dessert/dessert4.png'

import salad1 from '../assets/salad/salad1.png'

import soda1 from '../assets/soda/soda1.png'
import soda2 from '../assets/soda/soda2.png'
import soda3 from '../assets/soda/soda3.png'

export const BURGER: IProduct[] = [
  {
    id: 1,
    name: 'Chickenburger',
    image: burger1,
    price: 15.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 2,
    name: 'Crunchy Guacamole',
    image: burger2,
    price: 25.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 3,
    name: 'Cheeseburger',
    image: burger3,
    price: 20.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 4,
    name: 'Burger Jr',
    image: burger4,
    price: 27.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 5,
    name: 'Double burger',
    image: burger5,
    price: 30.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 6,
    name: 'Double veggie burger',
    image: burger6,
    price: 17.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 7,
    name: 'BBQ Burger',
    image: burger7,
    price: 32.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 8,
    name: 'Bacon burger',
    image: burger8,
    price: 25.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 9,
    name: 'Big burger with bacon',
    image: burger9,
    price: 40.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 10,
    name: 'BBQ Bacon Burger',
    image: burger10,
    price: 30.00,
    information: 'Lorem ipsum dolor'
  }
]

export const BREAKFAST: IProduct[] = [
  {
    id: 11,
    name: 'Simple breakfast',
    image: breakfast1,
    price: 13.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 12,
    name: 'Full breakfast',
    image: breakfast2,
    price: 25.00,
    information: 'Lorem ipsum dolor'
  }
]

export const DESSERT: IProduct[] = [
  {
    id: 13,
    name: 'Nutella filled cone',
    image: dessert1,
    price: 5.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 14,
    name: 'Chocolate Brownies',
    image: dessert2,
    price: 7.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 15,
    name: 'Milk shake',
    image: dessert3,
    price: 3.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 16,
    name: 'Chocolate pie',
    image: dessert4,
    price: 10.00,
    information: 'Lorem ipsum dolor'
  }
]

export const SALAD: IProduct[] = [
  {
    id: 17,
    name: 'Salad',
    image: salad1,
    price: 8.00,
    information: 'Lorem ipsum dolor'
  }
]

export const SODA: IProduct[] = [
  {
    id: 18,
    name: 'Orange juice',
    image: soda1,
    price: 3.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 19,
    name: 'Epura',
    image: soda2,
    price: 1.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 20,
    name: 'American coffee',
    image: soda3,
    price: 5.00,
    information: 'Lorem ipsum dolor'
  }
]

export const OURPRODUCTS: IProduct[] = [
  {
    id: 11,
    name: 'Simple breakfast',
    image: breakfast1,
    price: 13.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 1,
    name: 'Chickenburger',
    image: burger1,
    price: 15.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 18,
    name: 'Orange juice',
    image: soda1,
    price: 3.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 7,
    name: 'BBQ Burger',
    image: burger7,
    price: 32.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 14,
    name: 'Chocolate Brownies',
    image: dessert2,
    price: 7.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 15,
    name: 'Milk shake',
    image: dessert3,
    price: 3.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 8,
    name: 'Bacon burger',
    image: burger8,
    price: 25.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 9,
    name: 'Big burger with bacon',
    image: burger9,
    price: 40.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 4,
    name: 'Burger Jr',
    image: burger4,
    price: 27.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 20,
    name: 'American coffee',
    image: soda3,
    price: 5.00,
    information: 'Lorem ipsum dolor'
  },
  {
    id: 2,
    name: 'Crunchy Guacamole',
    image: burger2,
    price: 25.00,
    information: 'Lorem ipsum dolor'
  }
]
